export default "38869b95af7b0626.svg"